export const mockAssets = [
  {
    id: 1,
    Title: "Composability with Library",
    Heading: "Explore Library content for interconnected manufacturing use cases",
    Image: "https://firebasestorage.googleapis.com/v0/b/vtec-27b63.appspot.com/o/assets%2FBubble_experience.png?alt=media&token=623e4a7c-2d50-4833-8ec2-ac0a49851799",
    isNew: true,
    partnerName: "Bubble Partner",
    redirectTo: "/experience/bubble",
    modal: true,
    type: "modal",
  },
  {
    id: 2,
    Title: "Interactive RA",
    Heading: "Interactive RA",
    Image: "https://firebasestorage.googleapis.com/v0/b/vtec-27b63.appspot.com/o/assets%2FScreenshot_2.png?alt=media&token=1415fa5c-3cfa-4b56-ad14-1dfd33c2e800",
    isNew: true,
    partnerName: "Interactive RA",
    redirectTo: "/experience/interactive-ra",
    type: "page",
  },
  {
    id: 3,
    Title: "Experience Stories",
    Heading: "Experience Stories",
    Image: "https://firebasestorage.googleapis.com/v0/b/vtec-27b63.appspot.com/o/assets%2FScreenshot_1.png?alt=media&token=18277260-bc92-4cd5-bcc5-668d14f671f9",
    isNew: true,
    partnerName: "Experience Stories",
    redirectTo: "/experience/stories",
    type: "page",
  },
  {
    id: 4,
    Title: "Experience Stories NDA",
    Heading: "Experience Stories NDA",
    Image: "https://firebasestorage.googleapis.com/v0/b/vtec-27b63.appspot.com/o/assets%2FScreenshot_1.png?alt=media&token=18277260-bc92-4cd5-bcc5-668d14f671f9",
    isNew: true,
    partnerName: "Experience Stories NDA",
    redirectTo: "/experience/stories/nda",
    type: "page",
  }
];
